import { render } from "./postFooter.vue?vue&type=template&id=1c091c1e&scoped=true"
import script from "./postFooter.vue?vue&type=script&lang=js"
export * from "./postFooter.vue?vue&type=script&lang=js"

import "./postFooter.vue?vue&type=style&index=0&id=1c091c1e&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c091c1e"]])

export default __exports__